import React, { PureComponent } from "react";
import { injectIntl, defineMessages } from "react-intl";

import { Map, List } from "immutable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, reset, touch, focus } from "redux-form";

import * as vali from "libs/validation";
import * as templateLib from "libs/templateLib";
import * as templateActions from "modules/template";

import { ExamTemplateEdit } from "components";

class CtExamTemplateEdit extends PureComponent {
  constructor(props) {
    super(props);

    //this.checkFieldCount = 0;
    this.state = {
      onProgress: true,
      fileExtValidMessage: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { invalid, editSaveNow, setEditInvalid, setDisableSave } = this.props;
    const { formStore } = nextProps;
    if (invalid !== nextProps.invalid && typeof setEditInvalid === "function") {
      setEditInvalid(nextProps.invalid);
    }

    if (nextProps.editSaveNow && nextProps.editSaveNow !== editSaveNow) {
      if (nextProps.invalid) {
        if (typeof setDisableSave === "function") {
          setDisableSave(true);
        }
        this.markFieldValidate("examTemplateEdit");
      } else {
        let isValid = true;

        // 원본파일명의 validation 체크 (attachInfoNo > 0: 첨부파일이 있을때만)
        if (
          formStore &&
          formStore.values &&
          formStore.values.attachInfoNo &&
          formStore.values.attachName
        ) {
          // 첨부파일 확장자 체크
          isValid = this.checkFileExt() ? false : true;

          // zip, 7z확장자 체크
          if (
            !!vali.extensionAttachCompress(formStore.values.attachCompressName)
          ) {
            isValid = false;
            // 첨부파일의 확장자와 압축 파일 종류가 다를경우
          } else if (
            (formStore.values.attachCompress === 1 &&
              vali.RegExpZip.test(formStore.values.attachCompressName)) ||
            (formStore.values.attachCompress === 2 &&
              vali.RegExp7z.test(formStore.values.attachCompressName))
          ) {
            isValid = false;
          }
        }

        if (isValid) {
          this.saveTemplate();
        } else {
          if (typeof setDisableSave === "function") {
            setDisableSave(true);
          }
          this.markFieldValidate("examTemplateEdit");
        }
      }
    }

    if (formStore && formStore.fields) {
      const errorType = [
        "syncErrors",
        "syncWarnings",
        "asyncErrors",
        "asyncWarnings",
      ];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === "function") {
                setDisableSave(true);
              }
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === "function") {
          setDisableSave(false);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      formStore,
      handleDisableSaveBtn,
      invalid,
      attachData,
      templatePhishing,
    } = this.props;

    if (
      formStore &&
      prevProps.formStore &&
      formStore.values &&
      prevProps.formStore.values
    ) {
      const {
        examType,
        phishingNo,
        templatePublic,
        attachInfoNo,
        attachType,
        linkAttach,
      } = formStore.values;

      // 훈련 유형, 공개 여부 설정 완료 시
      if (
        !invalid &&
        examType !== "" &&
        examType > -1 &&
        templatePublic !== "" &&
        templatePublic > -1
      ) {
        // 피싱 유도
        if (examType === 4) {
          // 피싱 유도 설정 선택 시 저장 버튼 활성화
          if (
            phishingNo > 0 &&
            templatePhishing
              .toJS()
              .map((value) => value.phishingNo)
              .indexOf(phishingNo) > -1
          ) {
            handleDisableSaveBtn(false);
          } else {
            handleDisableSaveBtn(true);
          }
        }
        // 경고 안내, 모의 악성파일, 실태 조사
        else {
          // 첨부파일 없음 선택 또는 첨부 유형 및 다운로드 유형 선택 완료 시, 삭제되지 않은 첨부파일 선택되어 있을 시 저장 버튼 활성화
          if (
            attachInfoNo === 0 ||
            (attachInfoNo > 0 &&
              attachType &&
              linkAttach &&
              attachData
                .toJS()
                .map((value) => value.attachInfoNo)
                .indexOf(attachInfoNo) > -1)
          ) {
            handleDisableSaveBtn(false);
          } else {
            handleDisableSaveBtn(true);
          }
        }
      }
    }
  }

  markFieldValidate = (formName) => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  // 첨부파일 확장자와 원본 파일명 확장자 일치 여부 체크
  checkFileExt = () => {
    const { formatMessage } = this.props.intl;
    const { attachData, formStore, attachIndexList } = this.props;
    if (
      !formStore ||
      !formStore.values.attachInfoNo ||
      formStore.values.examType === 4 ||
      !formStore.values.attachName
    )
      return;

    const currentAttachData = attachData
      .get(String(attachIndexList.get(String(formStore.values.attachInfoNo))))
      .toJS();
    const fileName = formStore.values.attachName;
    
    const extension = fileName
      .substring(fileName.lastIndexOf(".") + 1)
      .toLowerCase();

    const errorMessage =
      !!fileName && extension !== currentAttachData.fileExt
        ? currentAttachData.fileExt
        : "";

    return errorMessage
      ? `${defineMessages(
          formatMessage({
            id: "ExamTemplateEdit_99",
            defaultMessage: "가능한 확장자",
          })
        )}: ${errorMessage}`
      : "";
  };

  saveTemplate = async () => {
    const { invalid, setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === "function") {
      setEditOnProgress(true);
    }
    this.setState({ onProgress: true });

    if (!invalid) {
      const {
        isAuth,
        formStore,
        templateInfo,
        TemplateActions,
        handleOnToggleEditModal,
      } = this.props;

      const params = {};
      if (formStore && formStore.values && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              if (
                typeof formStore.values[field] !== "undefined" &&
                formStore.values[field] !== templateInfo[field]
              ) {
                params[field] = formStore.values[field];
              }
            }
          }
        }

        if (
          // 훈련 유형이 감염 파일 (단 첨부없음이 아닐때)
          formStore.values.examType === 1 &&
          formStore.values.attachInfoNo > 0 &&
          // 다운로드 유형이 선택 안된 경우
          (formStore.values.linkAttach === 0 ||
            // 첨부 유형이 선택 안된 경우
            formStore.values.attachType === 0)
        ) {
          handleOnToggleEditModal();
          return false;
        }
      }

      let preparedParams = false;
      if (Object.keys(params).length > 0) {
        if (!!!templateInfo.serviceTemplateNo) {
          if (isAuth === 2) {
            params.examTemplateNo = templateInfo.templateNo;
            preparedParams = true;
          }
        } else {
          params.serviceTemplateNo = templateInfo.serviceTemplateNo;
          preparedParams = true;
        }
      }

      if (preparedParams) {
        //
        try {
          await TemplateActions.updateTemplate(params);
        } catch (e) {
          console.log(e);
        }
      } else {
        // 업데이트 할 것이 없음
      }
      handleOnToggleEditModal();
    } else {
      // invalid
    }
  };

  uploadBodyImage = (file) => {
    const {
      templateInfo: { templateNo, serviceTemplateNo },
    } = this.props;
    const data = new FormData();
    if (!!!serviceTemplateNo) {
      data.append("examTemplateNo", templateNo);
    } else {
      data.append("serviceTemplateNo", serviceTemplateNo);
    }
    // data.append('file', file[0]);
    data.append("file", file);

    return templateLib.uploadExamTemplateBodyImage(data);
  };

  handleOnOpenEditModal = () => {
    const { setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === "function") {
      setEditOnProgress(false);
    }
    this.setState({ onProgress: false });
  };

  render() {
    const { onProgress } = this.state;
    const {
      addMode,
      isAuth,
      formStore,
      invalid,
      templateInfo,
      handleOnToggleEditModal,
      attachData,
      templatePhishing,
      templateData,
      attachIndexList,
    } = this.props;
    const { handleOnOpenEditModal, uploadBodyImage, checkFileExt } = this;

    return (
      <ExamTemplateEdit
        dispatch={this.props.dispatch}
        addMode={addMode}
        isAuth={isAuth}
        onProgress={onProgress}
        formStore={formStore}
        invalid={invalid}
        templateInfo={templateInfo}
        uploadBodyImage={uploadBodyImage}
        handleOnOpenEditModal={handleOnOpenEditModal}
        handleOnToggleEditModal={handleOnToggleEditModal}
        attachData={attachData}
        templatePhishing={templatePhishing}
        templateData={templateData}
        attachIndexList={attachIndexList}
        checkFileExt={checkFileExt}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { templateInfo } = props;

  let templateData = state.template.get("data");
  if (templateData && Map.isMap(templateData)) {
    templateData = templateData.toJS().success;
  } else {
    templateData = [];
  }

  return {
    initialValues: templateInfo,
    formStore: state.form["examTemplateEdit"],
    attachData: state.templateAttach.getIn(["data", "success"]),
    templatePhishing: state.template.getIn(["templatePhishing", "success"]),
    attachIndexList: state.templateAttach.get("listIndexByNo"),
    templateData: templateData,
    isAuth: state.user.get("isAuth"),
    file: props.uploadBodyImage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  TemplateActions: bindActionCreators(templateActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "examTemplateEdit",
    asyncBlurFields: ["attachName"],
    destroyOnUnmount: false,
    enableReinitialize: true,
    touchOnChange: true,
  })(injectIntl(CtExamTemplateEdit))
);



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateEdit.js